// assistantFlyPeople.js — FLY CALLS ANYONE IN THE WORKSPACE (Nika 2026-10-23:
// "add calling mode into fly so you can call to anyone in workspace").
//
// The start screen showed the members as a row once (Nika 2026-10-23: "instead
// of call, change to members, add popover to those"); the row left it the
// same day ("remove members from init fly"). The roster stays for the call
// ask below (assistantFlyCallRoster, the whole roster).
//
// An ask that is a call (functions/callPerson.js, with a transcript so its
// summary builds during the call):
//   an ask                      "call Nika", "ring thomas", "დაურეკე ნიკას" — a
//                               Fly ask that names ONE member calls them instead
//                               of composing a page (assistantFlyCallIntent);
//                               anything else, or a name two people share, is
//                               an ordinary ask
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.

// The workspace's people a call can name: the active members but the person
// themself, the ones online first, then by name; at most `limit` (8; 0 = all —
// the call ask reads them all). Read keys: the roster, the presence map, the
// person (reactive callers).
export const assistantFlyCallRoster = function assistantFlyCallRoster(root, limit) {
  const r = root && typeof root === 'object' ? root : {}
  const fns = (this && this.context && this.context.functions) || {}
  const all =
    typeof fns.activeMembers === 'function'
      ? this.call('activeMembers', r) || []
      : Array.isArray(r.people)
        ? r.people
        : []
  const presence = (r.presenceById && typeof r.presenceById === 'object' && r.presenceById) || {}
  const meEmail = String(r.currentUserEmail || '').toLowerCase()
  const meId = String(r.currentUserId || '')
  // 8 by default; the call ask searches the whole roster (`limit` 0)
  const want = Math.floor(Number(limit))
  const max = want === 0 ? Infinity : Math.max(1, Math.min(24, want || 8))
  const rows = []
  const seen = new Set()
  for (const p of Array.isArray(all) ? all : []) {
    if (!p || typeof p !== 'object') continue
    const email = String(p.email || '').toLowerCase()
    const userId = p.userId ? String(p.userId) : ''
    if ((email && email === meEmail) || (userId && userId === meId)) continue
    const key = userId || email
    if (!key || seen.has(key)) continue
    seen.add(key)
    const name = String(p.name || p.email || '').trim()
    if (!name) continue
    rows.push({
      key: 'person-' + key.replace(/[^A-Za-z0-9_-]/g, '_'),
      // every key a value (a row's empty key would read the root's)
      userId: userId || '',
      email: email || '',
      name,
      avatar: typeof p.avatar === 'string' ? p.avatar : '',
      initials: typeof p.initials === 'string' ? p.initials : '',
      online: !!((email && presence[email]) || (userId && presence[userId]))
    })
  }
  rows.sort((a, b) => Number(b.online) - Number(a.online) || a.name.localeCompare(b.name))
  return rows.slice(0, max)
}

// A member called — a "call <name>" ask (functions/homeAiSend.js).
export const assistantFlyCallPerson = function assistantFlyCallPerson(s) {
  if (!s || (!s.userId && !s.email)) return false
  const who = { userId: s.userId || '', email: s.email || '', name: s.name || '' }
  this.call('callPerson', who, { transcribe: true })
  return true
}

// An ask that is a call: the member it names, or null. Verbs in English and
// Georgian; a leading "please" and a closing mark are allowed; the name is
// matched case-insensitively against a member's full name, first name or the
// local part of their email — ONE member, or no call.
export const assistantFlyCallIntent = function assistantFlyCallIntent(root, text) {
  const raw = String(text || '').trim()
  if (!raw || raw.length > 80) return null
  const forms = [
    /^(?:please\s+)?(?:call|ring|phone|video\s*call|start\s+a\s+call\s+with|get\s+on\s+a\s+call\s+with)\s+(.+?)\s*[.!?]*$/i,
    /^(?:დაურეკე|დარეკე|დაუკავშირდი)\s+(.+?)\s*[.!?]*$/u
  ]
  let name = null
  for (const re of forms) {
    const m = re.exec(raw)
    if (m) {
      name = m[1]
      break
    }
  }
  if (!name) return null
  const q = name
    .replace(/^@/, '')
    .replace(/\s+(now|please)$/i, '')
    .trim()
    .toLowerCase()
  if (!q) return null
  // Georgian dative/ergative endings on a first name ("ნიკას", "თომასს").
  const stems = [q, q.replace(/(ს|ის|მა|მ)$/u, '')].filter(Boolean)
  const people = this.call('assistantFlyCallRoster', root, 0) || []
  const hits = people.filter((p) => {
    const full = String(p.name || '').toLowerCase()
    const first = full.split(/\s+/)[0] || ''
    const local = String(p.email || '')
      .split('@')[0]
      .toLowerCase()
    return stems.some((n) => n === full || n === first || (local && n === local))
  })
  return hits.length === 1 ? hits[0] : null
}
